module.exports = __webpack_public_path__ + "img/iso18001.fb90c439.png";